var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.266,
    height: 20,
    viewBox: "0 0 25.266 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(-184.802 -140.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77688",
    "data-name": "Path 77688",
    d: "M208.569,140.236H186.3a1.425,1.425,0,0,0-1.5,1.34v17.315a1.425,1.425,0,0,0,1.5,1.34h22.268a1.425,1.425,0,0,0,1.5-1.34V141.576a1.425,1.425,0,0,0-1.5-1.34ZM193.8,153.791V150.01h7.28v3.781Zm7.28,1.285v3.854H193.8v-3.854Zm0-10.149v3.781H193.8v-3.781Zm7.708,0v3.781H202.36v-3.781Zm-16.273,3.781h-6.424v-3.781h6.424Zm-6.424,1.285h6.424v3.8h-6.424Zm16.273,0h6.424v3.8H202.36ZM186.3,141.52H208.57a.466.466,0,0,1,.214.056v2.066h-22.7V141.6a.274.274,0,0,1,.214-.082Zm-.214,17.371v-3.815h6.424v3.854H186.3a.509.509,0,0,1-.214-.039Zm22.482.056H202.36v-3.854h6.424v3.79a.274.274,0,0,1-.214.064Z",
    transform: "translate(0 0)",
    fill: "#f45e29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/table-icon.20c6a1f8.svg";
export { ForwardRef as ReactComponent };